import { h, Component } from 'preact';
import { route } from 'preact-router';
import PFeed from '../../../services/prematch-feed';
import Page from '../../../services/page-data-feed';
import * as P from '../mobile-templates/tournament.jsx';
import Ticket from "../utils/ticket-logic.jsx";
import { StatsIconRegular } from '../utils/icons.jsx';
import { Pagination } from '../desktop-components/today-widget.jsx';
import { RegionFlagIcon } from '../desktop-templates/prematch-menu.jsx';
import { CardHeaderTitle } from '../desktop-templates/prematch-tournament.jsx';
import { MobileEvent } from '../mobile-pages/prematch-tournament';

export class TodayWidget extends Component {
    state = {
        tournaments: [],
        currentPage: 1,
    };

    componentDidMount() {
        this.fetchTournaments();
    }

    fetchTournaments() {
        const today = new Date();
        const endOfDay = new Date(today.setHours(23, 59, 59, 999)).getTime();

        PFeed.getMenu((label, menu) => {
            let tournaments = [];
            Object.values(menu[this.props.sport.id].sub).forEach(category => {
                Object.values(category.sub).forEach(tournament => {
                    if (tournament['next-event'] <= endOfDay) {
                        tournaments.push({
                            ...tournament,
                            categoryOrder: category.order,
                            tournamentOrder: tournament.order
                        });
                    }
                });
            });

            tournaments = tournaments.sort((a, b) => a.categoryOrder == 0 ? b.categoryOrder : a.categoryOrder - b.categoryOrder)
                .sort((a, b) => a.tournamentOrder == 0 ? b.tournamentOrder : a.tournamentOrder - b.tournamentOrder);

            const topLeagues = tournaments.filter(tournament => PFeed.mainTournaments.includes(tournament.id));
            const otherTournaments = tournaments.filter(tournament => !PFeed.mainTournaments.includes(tournament.id));

            this.setState({ tournaments: [...topLeagues, ...otherTournaments] });
        });
    }

    handlePageChange = (page) => {
        this.setState({ currentPage: page });
    };

    render({ sport }) {
        const { tournaments, currentPage } = this.state;
        const tournamentsPerPage = 5;
        const totalPages = Math.ceil(tournaments.length / tournamentsPerPage);
        const displayedTournaments = tournaments.slice((currentPage - 1) * tournamentsPerPage, currentPage * tournamentsPerPage);

        return (
            <div>
                <div class="bg-slate-100">
                    {displayedTournaments.map(tournament => (
                        <TournamentDisplay tournament={tournament} key={tournament.id} />
                    ))}
                </div>
                <Pagination totalPages={totalPages} currentPage={currentPage} onPageChange={this.handlePageChange} />
            </div>
        );
    }
}

// New component for displaying tournament
class TournamentDisplay extends Component {
    render() {
        const { tournament } = this.props;
        return (
            <div class="pb-0.5 bg-slate-50 border-b border-slate-200">
                <div class="flex items-center py-1 gap-1">
                    <div class="pl-2">
                        <div class="h-4 w-6 flex items-center justify-center">
                            <RegionFlagIcon
                                category={PFeed.getWithParents(tournament.parent).category}
                            />
                        </div>
                    </div>
                    <CardHeaderTitle>{PFeed.getWithParents(tournament.parent).category.name} - {tournament.name}</CardHeaderTitle>
                </div>
                <DailyEventDisplay tournament={tournament} />
            </div>
        );
    }
}
export class DailyEventDisplay extends Component {
    state = {
        tournamentData: null,
    };

    componentDidMount() {
        this.fetchTournamentData();
    }

    fetchTournamentData() {
        const { tournament } = this.props;
        PFeed.callTournament(tournament.id, {}, (tag, data) => {
            this.setState({ tournamentData: data });
        });
    }

    render() {
        const { tournamentData } = this.state;
        if (!tournamentData) return <div></div>;

        const today = new Date();
        const endOfDay = new Date(today.setHours(23, 59, 59, 999)).getTime() / 1000;
        const eventsToday = Object.values(tournamentData.sub).filter(event => event.date <= endOfDay);

        const { sport, category, tournament } = PFeed.getWithParents(this.props.tournament.id);
        const displayRuleFiltered = this.displayRuleOnlyOneMarket(tournamentData.displayRule);

        return (
            <div>
                {eventsToday.map(event => (
                    <MobileEvent
                        tournament={tournament}
                        event={event}
                        displayRuleFiltered={displayRuleFiltered}
                    />
                ))}
            </div>
        );
    }

    displayRuleOnlyOneMarket(displayRule) {
        const firstMarket = displayRule[0].id.split('.')[0];
        return displayRule.filter(outcome => outcome.id.split('.')[0] === firstMarket);
    }
}
